// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"JobDetails_mainTitle__2FLM6","iconListItem":"JobDetails_iconListItem__3dM4b","iconLabelSet":"JobDetails_iconLabelSet__1_Qy7","iconSet":"JobDetails_iconSet__2S1oP"};